import { useTranslation } from 'react-i18next';

import FirefliesConfig from './components/FirefliesConfig';
import TranscriptDetailModal from './components/TranscriptDetailModal';
import TranscriptList from './components/TranscriptList';
import { useFirefliesLogic } from './hooks/useFirefliesLogic';

import type { FirefliesMetadata } from './types';

interface FirefliesProps {
  widgetId: string;
  metadata?: Record<string, unknown>;
}

export default function Fireflies({ metadata }: FirefliesProps) {
  const { t } = useTranslation();
  const meta = metadata as FirefliesMetadata | undefined;
  const apiKey = meta?.apiKey ?? '';
  const userEmail = meta?.userEmail ?? '';

  const {
    transcripts,
    selectedTranscript,
    detailTranscript,
    lastFetchedAt,
    loading,
    error,
    hasNotesWidget,
    hasChecklistWidget,
    clearError,
    handleRefresh,
    handleOpenDetail,
    handleCloseDetail,
    handleSaveToNotes,
    handleAddToChecklist,
    handleAddActionToChecklist,
  } = useFirefliesLogic(apiKey, userEmail);

  if (!apiKey) {
    return (
      <div className="h-full flex flex-col items-center justify-center p-4">
        <p className="text-gray-500 text-sm text-center">{t('fireflies.setupPrompt')}</p>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <TranscriptList
        error={error}
        hasChecklistWidget={hasChecklistWidget}
        hasNotesWidget={hasNotesWidget}
        lastFetchedAt={lastFetchedAt}
        loading={loading}
        transcripts={transcripts}
        userEmail={userEmail}
        onAddToChecklist={handleAddToChecklist}
        onClearError={clearError}
        onOpenDetail={handleOpenDetail}
        onRefresh={handleRefresh}
        onSaveToNotes={handleSaveToNotes}
      />

      <TranscriptDetailModal
        hasChecklistWidget={hasChecklistWidget}
        hasNotesWidget={hasNotesWidget}
        isOpen={!!selectedTranscript}
        transcript={detailTranscript}
        userEmail={userEmail}
        onAddActionToChecklist={handleAddActionToChecklist}
        onClose={handleCloseDetail}
        onSaveToNotes={handleSaveToNotes}
      />
    </div>
  );
}

export { FirefliesConfig };
